module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("It's been " + _vm._s(_vm.days.served) + " days since this dumpster 🔥 of a Presidency began...")]), _c('h1', [_vm._v("There are " + _vm._s(_vm.days.left) + " days left. The term is only " + _vm._s((_vm.days.served / _vm.days.term).toFixed(2) * 100) + "% over... 😰")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ef48e28"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Days.vue
// module id = 1082
// module chunks = 1